import "./NewWatchlistItemComponent.scss";
import template from "./NewWatchlistItemComponent.html";
import {IComponentOptions} from "angular";
import {WatchListComponentController} from "../watchlist/WatchListComponent";
import {CompanyInfo} from "../../../types/Company";
import {ObjectUtil} from "../../../js/util/ObjectUtil";

export const NewWatchlistItem = "tfNewWatchListItem";

export function newWatchlistItem(): IComponentOptions {
    return {
        template,
        require: {
            watchlist: "^^tfWatchList"
        },
        controllerAs: "ctrl",
        controller: NewWatchlistItemComponentController
    };
}

export class NewWatchlistItemComponentController {

    public readonly watchlist: WatchListComponentController;

    public addCompany(company: CompanyInfo) {
        const security = ObjectUtil.pick(company, "code", "exchange");
        this.watchlist.addItem(security);
    }

    public onBlur() {
        this.watchlist.addItemBlurred();
    }
}
